export const DEFAULT_GATEWAY_URI = 'https://ipfs.io'
